(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9471],{

/***/ 40085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ CalendarPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/index.tsx + 3 modules
var Ir = __webpack_require__(82319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Heading.tsx
var Heading = __webpack_require__(3319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Mpocket/Accordion.tsx
var Accordion = __webpack_require__(99515);
// EXTERNAL MODULE: ./src/hooks/useMpocketScript.ts
var useMpocketScript = __webpack_require__(98259);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Calendar/index.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var CalendarPage = function CalendarPage(_ref) {
  var items = _ref.items;
  (0,useMpocketScript/* useMpocketScript */.k)('//irpocket.com/141A/irpocket/config-utils-main_en.js'); // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main_en.js')

  var groupByItemName = function groupByItemName(data) {
    var sortedData = (0,toConsumableArray/* default */.Z)(data).sort(function (a, b) {
      return new Date(b.published).getTime() - new Date(a.published).getTime();
    });

    var grouped = sortedData.reduce(function (acc, item) {
      if (!acc[item.itemName]) {
        acc[item.itemName] = {
          itemName: item.itemName,
          itemName_en: item.itemName_en,
          items: []
        };
      }

      acc[item.itemName].items.push(item);
      return acc;
    }, {});
    return Object.values(grouped);
  };

  var groupedData = groupByItemName(items);

  var _useState = (0,react.useState)(function () {
    var initialState = {};

    if (groupedData.length > 0) {
      initialState[0] = true;
    }

    return initialState;
  }),
      openStates = _useState[0],
      setOpenStates = _useState[1];

  var toggleOpen = function toggleOpen(index) {
    setOpenStates(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, index, !prev[index]));
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      enTitleText: "IR Calendar",
      subTitleText: ""
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "IR Calendar"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          media: "(max-width: 1047px)",
          srcSet: "/images/IRCalendarSP.webp",
          width: "335",
          height: "433"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          src: "/images/IRCalendarPC2.png",
          alt: "IR\u30AB\u30EC\u30F3\u30C0\u30FC",
          width: "1040",
          height: "300"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 50,
        pc: 80
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
      children: groupedData.map(function (item, index) {
        var isOpen = openStates[index] || false;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            onClick: function onClick() {
              return toggleOpen(index);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: isOpen ? 'iZwYFc' : ''
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              children: item.itemName_en
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: isOpen ? '' : 'bkpqNp',
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              children: item.items.map(function (a, b) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("time", {
                    children: formatDate(a.published)
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        href: a.link_en,
                        target: a.target,
                        children: a.title_en
                      })
                    })
                  })]
                }, b);
              })
            })
          })]
        }, item.itemName);
      })
    })]
  });
};

var formatDate = function formatDate(date) {
  return new Date(date).toLocaleDateString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).replace(/\//g, "/");
};

CalendarPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Investor Relations',
    path: '/en/ir'
  }, {
    name: 'IR Calendar',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "IR Calendar",
      description: "IR event schedule.",
      ogp: {
        url: 'en/ir/calendar/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Calendar__Image",
  componentId: "sc-q8hfix-0"
})(["width:100%;height:100%;"]);
;// CONCATENATED MODULE: ./src/pages/en/ir/calendar/index.tsx
var __N_SSG = true;


/***/ }),

/***/ 26228:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/calendar",
      function () {
        return __webpack_require__(40085);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,4591,403,9774,2888,179], function() { return __webpack_exec__(26228); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);